/* Keep the header search modal in a deterministic state across navigation. */
(function () {
  'use strict';

  function initialiseSearchOverlay() {
    var root = document.querySelector('.header__search');
    if (!root || root.dataset.iuhSearchGuardReady === 'true') return;

    var modal = root.querySelector('.detail-modal');
    var dialog = root.querySelector('.search-modal');
    var overlay = root.querySelector('.modal-overlay');
    var input = root.querySelector('input[type="search"]');
    var toggle = root.querySelector('.modal__toggle');
    if (!modal) return;

    root.dataset.iuhSearchGuardReady = 'true';

    function clearSuggestions() {
      var predictiveSearch = root.querySelector('predictive-search');
      var results = root.querySelector('.predictive-search');

      if (predictiveSearch && typeof predictiveSearch.close === 'function') {
        // Keep the query intact until the browser serializes a submitted form.
        predictiveSearch.close(false);
      } else if (results) {
        results.innerHTML = '';
        results.style.display = 'none';
      }
    }

    function closeSearch() {
      modal.classList.remove('active');
      if (dialog) {
        dialog.hidden = true;
        dialog.inert = true;
        dialog.setAttribute('aria-hidden', 'true');
        dialog.style.setProperty('display', 'none', 'important');
      }
      if (overlay) overlay.classList.remove('active');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (input) input.blur();
      clearSuggestions();
    }

    function openSearch() {
      if (dialog) {
        dialog.hidden = false;
        dialog.inert = false;
        dialog.removeAttribute('aria-hidden');
        dialog.style.removeProperty('display');
      }
      modal.classList.add('active');
      if (overlay) overlay.classList.add('active');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (input && window.matchMedia('(min-width: 992px)').matches) input.focus();
    }

    /* Capture the event before the legacy toggle handler can invert state. */
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('.header__search .modal__toggle, .modal__toggle-search-mobile');
      if (opener) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openSearch();
        return;
      }

      var closer = event.target.closest('.header__search .search-modal__close-button, .header__search .modal-overlay');
      if (closer) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeSearch();
        return;
      }

      if (event.target.closest('.header__search .search-modal a[href]')) closeSearch();
    }, true);

    root.querySelectorAll('form[role="search"]').forEach(function (form) {
      form.addEventListener('submit', closeSearch);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('active')) closeSearch();
    });

    window.addEventListener('pagehide', closeSearch);
    window.addEventListener('pageshow', closeSearch);
    closeSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseSearchOverlay, { once: true });
  } else {
    initialiseSearchOverlay();
  }
})();
